import { transparentize } from 'polished';
import { startTransition } from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import AppStateView from 'src/AppStateView';
import FormattedHtmlMessage from 'src/easyclaim.app.components/common/FormattedHtmlMessage';
import {
	ReviewCanMoveNextIcon,
	ReviewCanNotMoveNextIcon,
} from 'src/easyclaim.app.components/common/ImageRepository';
import styled, { css } from 'styled-components';

import {
	Circle,
	DetailContainer,
	DetailsContainer,
	FadeIn,
	StyledIconCheck,
	StyledIconInvalid,
} from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { ScreenComponent } from './ScreenComponent';

export class Review extends ScreenComponent<AppState, object> {
	constructor(props: AppState) {
		super(props);

		this.state = {
			isCompleteReviewModalOpen: false,
		};
	}

	private ableToShoweditViewButton = (step: AppStateView, allowAutoMoveNext: boolean) => {
		if (allowAutoMoveNext) {
			if (!!this.props && !!step.canMoveNext) {
				return !step.canMoveNext(this.props);
			}

			return false;
		}

		return true;
	};

	public render() {
		const configuration = this.props.easyClaimCase && this.props.easyClaimCase._configuration;

		if (!configuration || !configuration.frontendSteps) {
			return;
		}

		const steps = configuration.frontendSteps.map((fs) => fs.appState!);
		const allowAutoMoveNext: boolean = !!configuration.allowAutoMoveNext;

		return (
			<div className="main-container">
				<h2 className="review-title">
					<FormattedMessage id="review.headline.first" />
				</h2>
				<DetailsContainer>
					<DetailContainer>
						<p className="review-paragraph-first">
							<FormattedHtmlMessage id="review.paragraph.first" />
						</p>
						<div>
							{this.props.appStateViews
								.filter(
									(step) =>
										!!step.appStateReviewDescriptionId &&
										steps.includes(step.appState) &&
										!!step.appStateReviewDescriptionId(this.props)
								)
								.sort((a, b) => (steps.indexOf(a.appState) < steps.indexOf(b.appState) ? -1 : 1))
								.map((step, i) => (
									<ReviewContainer key={i}>
										<Step>
											<Name className="review-step-name">
												<FormattedHtmlMessage id={step.appStateReviewDescriptionId!(this.props)} />
											</Name>
											{this.ableToShoweditViewButton(step, allowAutoMoveNext) && (
												<button
													className="button-secondary button-small review-step-button"
													onClick={() => {
														startTransition(() => {
															const newState = Object.assign({}, this.props, {
																screen: step.appState,
															});

															void this.props.setAppState(newState);
														});
													}}
												>
													<FormattedMessage id="review.editViewButton" />
												</button>
											)}
										</Step>
										{step.canMoveNext && step.canMoveNext(this.props) ? (
											<BottomCircle
												className="review-step-circle-valid"
												borderWidth="1px"
												borderStyle="solid"
											>
												<ReviewCanMoveNextIcon />
											</BottomCircle>
										) : (
											<BottomCircle
												className="review-step-circle-invalid"
												borderWidth="1px"
												borderStyle="solid"
											>
												<ReviewCanNotMoveNextIcon />
											</BottomCircle>
										)}
									</ReviewContainer>
								))}
						</div>
					</DetailContainer>
				</DetailsContainer>
			</div>
		);
	}
}

const BottomCircle = styled(Circle)`
	height: 1rem;
	bottom: 1rem;
	right: 1rem;
	animation: ${css`
			${FadeIn}`} 0.3s ease-in forwards;
`;

const Name = styled.div`
	margin-bottom: 1rem;
	user-select: none;
	cursor: default;
`;

const Step = styled.div`
	flex-basis: 60%;
	display: flex;
	flex-direction: column;
	padding-right: 1rem;
`;

const ReviewContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	&:first-child {
		padding-top: 2rem;
	}
	&:last-child {
		padding-bottom: 2rem;
	}
	&:not(:first-child) {
		padding-top: 1.5rem;
	}
	&:not(:last-child) {
		padding-bottom: 1.5rem;
		border-bottom: 1px solid ${(p) => transparentize(0.8, p.theme.colors.secondary)};
	}
`;
